import axios from 'axios';
import qs from 'qs';
import { cacheResponseData } from '../cache';
import * as featureFlags from './featuresApi';
import * as holiday from './holidayApi';
import * as settings from './settingsApi';
import * as teamCalendar from './teamCalendarApi';
import * as teamSummary from './teamSummaryApi';
import * as user from './userApi';
export const dateTimeReviver = (_, value) => {
    if (typeof value === 'string') {
        // ISO date regex
        const isIsoDate = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)((-(\d{2}):(\d{2})|Z|\+(\d{2}):(\d{2}))?)$/.test(value);
        if (isIsoDate) {
            return new Date(value);
        }
    }
    return value;
};
const dataTransform = (data) => {
    if (!data || typeof data !== 'string') {
        return data;
    }
    return JSON.parse(data, dateTimeReviver);
};
export const createAxios = ({ getAccessToken, baseURL }) => {
    const axiosInstance = axios.create({
        baseURL,
        headers: { 'Content-Type': 'application/json' },
        paramsSerializer: (params) => {
            return qs.stringify(params, { arrayFormat: 'repeat' });
        },
    });
    axiosInstance.interceptors.response.use(function (response) {
        cacheResponseData(response);
        return response;
    }, function (error) {
        return Promise.reject(error);
    });
    axiosInstance.defaults.transformResponse = dataTransform;
    axiosInstance.interceptors.request.use(async (config) => {
        const controller = new AbortController();
        if (!navigator.onLine) {
            controller.abort();
            return {
                ...config,
                signal: controller.signal,
            };
        }
        if (config.headers && !config.skipAuth) {
            const token = await getAccessToken();
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    });
    return axiosInstance;
};
export const createApi = ({ getAccessToken, baseURL }) => {
    axios.interceptors.response.use(function (response) {
        cacheResponseData(response);
        return response;
    }, function (error) {
        return Promise.reject(error);
    });
    axios.defaults.headers.common['Content-Type'] = 'application/json';
    axios.defaults.transformResponse = dataTransform;
    axios.interceptors.request.use(async (config) => {
        const controller = new AbortController();
        if (!navigator.onLine) {
            controller.abort();
            return {
                ...config,
                signal: controller.signal,
            };
        }
        // This allows overriding the baseURL in request
        if (!config.baseURL) {
            config.baseURL =
                baseURL || (typeof window !== 'undefined' ? window.location.origin : '');
        }
        if (config.headers && !config.skipAuth) {
            const token = await getAccessToken();
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    });
    return {
        user,
        holiday,
        featureFlags,
        settings,
        teamCalendar,
        teamSummary,
    };
};
